import mem from "mem";

import { axiosPrivate } from "../api/axios";

const RefreshToken = async() => {
    const session = JSON.parse(localStorage.getItem("crmSite"));
    try {
        const response = await axiosPrivate.post("/auth/token", {
            refreshtoken: session?.refreshJWT,
        });

        const { session }= response.data;
console.log("session");
console.log(session);
        if(!session?.accessJWT){
            localStorage.removeItem("crmSite");
            localStorage.removeItem("accessIsLogIn");
            localStorage.removeItem("accessJWT");
            localStorage.removeItem("accessUserID");
        }

        localStorage.setItem(
            'crmSite',
            JSON.stringify({ refreshJWT: response.data.refreshtoken, access: response.data.token })
        );

        return session;
        
    } catch (error) {
        localStorage.removeItem("crmSite");
        localStorage.removeItem("accessIsLogIn");
        localStorage.removeItem("accessJWT");
        localStorage.removeItem("accessUserID");

        
    }
};

const maxAge = 10000;

export const memoizedRefreshToken = mem(RefreshToken, {
    maxAge,
});